const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5215';

// ─── Template CRUD ─────────────────────────────────────────

export const getTemplates = async () => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates`);
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const getTemplate = async (apiType) => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/${encodeURIComponent(apiType)}`);
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const upsertTemplate = async (request) => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const deleteTemplate = async (apiType) => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/${encodeURIComponent(apiType)}`, { method: 'DELETE' });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const seedTemplates = async () => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/seed`, { method: 'POST' });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const mergeSeedTemplates = async () => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/seed/merge`, { method: 'POST' });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

// ─── Drift Detection ───────────────────────────────────────

export const detectDrift = async (apiType, targets = []) => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/${encodeURIComponent(apiType)}/drift`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(targets),
  });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};

export const fixDrift = async (request) => {
  const res = await fetch(`${API_BASE_URL}/api/env-templates/drift/fix`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(request),
  });
  const data = await res.json();
  if (!res.ok) throw Object.assign(new Error(data?.error || res.statusText), { status: res.status });
  return data;
};
